module.exports = __webpack_public_path__ + "static/media/readiness-received-icon.d6b10bb3.svg";